// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { createSvgIcon } from '@mui/material/utils';
import React from 'react';
export var CheckboxEmptyIcon = createSvgIcon(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("rect", {
    className: "checkboxEmptyFill",
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    fill: "none"
}), /*#__PURE__*/ React.createElement("path", {
    className: "checkboxEmptyBorder",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM5 19L5 5H19V19H5Z"
})), 'CheckboxEmpty');
export var CheckboxIcon = createSvgIcon(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.8C3 3.80589 3.80589 3 4.8 3H19.2C20.1941 3 21 3.80589 21 4.8V19.2C21 20.1941 20.1941 21 19.2 21H4.8C3.80589 21 3 20.1941 3 19.2V4.8ZM10.8235 15.7691L16.7176 9.69648L15.2824 8.30353L10.8235 12.8975L8.71757 10.7278L7.28241 12.1207L10.8235 15.7691Z"
})), 'Checkbox');
export var CheckboxIndeterminateIcon = createSvgIcon(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.8C3 3.80589 3.80589 3 4.8 3H19.2C20.1941 3 21 3.80589 21 4.8V19.2C21 20.1941 20.1941 21 19.2 21H4.8C3.80589 21 3 20.1941 3 19.2V4.8ZM16 13H8V11H16V13Z"
}), /*#__PURE__*/ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.8C3 3.80589 3.80589 3 4.8 3H19.2C20.1941 3 21 3.80589 21 4.8V19.2C21 20.1941 20.1941 21 19.2 21H4.8C3.80589 21 3 20.1941 3 19.2V4.8ZM16 13H8V11H16V13Z"
})), 'CheckboxIndeterminate');
export var CaratDownIcon = createSvgIcon(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.914 9.50025C19.305 9.10925 19.305 8.47725 18.914 8.08625C18.523 7.69525 17.891 7.69525 17.5 8.08625L12.207 13.3792L6.91403 8.08625C6.52303 7.69525 5.89102 7.69525 5.50002 8.08625C5.30503 8.28125 5.20703 8.53725 5.20703 8.79325C5.20703 9.04925 5.30503 9.30525 5.50002 9.50025L12.207 16.2072L18.914 9.50025Z"
})), 'CaratDown');

//# sourceMappingURL=icons.js.map